import { Injectable, NgZone } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  public on(event: string, callback: (...args: any[]) => void): void {
  this.socket.on(event, (...args: any[]) => {
    this.ngZone.run(() => callback(...args));
  });
}
  public socket: Socket;

  constructor(
    private router: Router,
    private message: NzMessageService,
    private ngZone: NgZone
  ) {
    this.socket = io(`${environment.root}cms`, {
      query: { token: localStorage.getItem('token') || '' },
      transports: ['websocket'], // Optional
    });

    this.socket.on('connect', () => {
      console.log('✅ WebSocket connected');
    });

    this.socket.on('error', (error: any) => {
      if (error?.type === 'UnauthorizedError') {
        localStorage.removeItem('token');
        this.router.navigate(['./login']);
        location.reload();
      }
    });

    this.socket.on('disconnect', (reason: string) => {
      this.handleDisconnection(reason);
    });
  }

  /**
   * Same as ngx-socket-io: Observable for event
   */
  public fromEvent<T = any>(eventName: string): Observable<T> {
    return new Observable<T>((subscriber) => {
      const listener = (data: T) => {
        this.ngZone.run(() => subscriber.next(data));
      };
      this.socket.on(eventName, listener);

      return () => {
        this.socket.off(eventName, listener);
      };
    });
  }

  /**
   * Same as ngx-socket-io: emit with optional callback
   */
  public emit(event: string, ...args: any[]): void {
    this.socket.emit(event, ...args);
  }

  /**
   * Used in some parts of your app: reconnect manually
   */
  public connect(): void {
    if (!this.socket.connected) {
      this.socket.connect();
    }
  }

  /**
   * Disconnect the socket
   */
  public disconnect(): void {
    this.socket.disconnect();
  }

  /**
   * Optional: Replace `ioSocket.connected` references
   */
  get ioSocket(): Socket {
    return this.socket;
  }

  private handleDisconnection(reason: string): void {
    this.message.error('WebSocket connection has been disconnected. Reason: ' + reason);
    console.warn('WebSocket connection has been disconnected. Reason: ' + reason);
  }







  // new code for the testing 
  // constructor(
  //   private router: Router,
  //   private message: NzMessageService,
  //   private ngZone: NgZone
  // ) {
  //   super({
  //     url: `${environment.root}cms`,
  //     options: { query: { token: localStorage.getItem('token') } },
  //   });

  //   this.logSocketEvents();
  // }

  // private logSocketEvents(): void {
  //   this.on('connect', () => {
  //     console.log('✅ WebSocket connected');
  //   });

  //   this.on('disconnect', (reason) => {
  //     this.handleDisconnection(reason);
  //   });

  //   this.on('error', (error) => {
  //     console.error('❌ WebSocket error:', error);
  //     if (error.type === 'UnauthorizedError') {
  //       localStorage.removeItem('token');
  //       this.router.navigate(['./login']);
  //       location.reload();
  //     }
  //   });
  // }

  // public on(event: string, callback: Function): void {
  //   console.log(`📥 Listening to event: ${event}`);
  //   super.on(event, (data: any) => {
  //     this.ngZone.run(() => {
  //       console.log(`📥 Event received: ${event}`, data);
  //       callback(data); // Ensure Angular's change detection is triggered
  //     });
  //   });
  // }

  // public emit(event: string, ...args: any[]): void {
  //   console.log(`📤 Emitting event: ${event}`, args);
  //   super.emit(event, ...args);
  // }

  // private handleDisconnection(reason: string): void {
  //   console.warn('⚠️ WebSocket disconnected. Reason:', reason);
  //   this.message.error('WebSocket connection has been disconnected. Reason: ' + reason);
  // }

  
 
}






















// import { Injectable } from '@angular/core';
// import * as io from 'socket.io-client';
// import { environment } from 'src/environments/environment';
// import { Router } from '@angular/router';
// import { NzMessageService } from 'ng-zorro-antd/message';

// @Injectable({
//   providedIn: 'root'
// })
// export class SocketService {
//   private socket: io.Socket;

//   constructor(private router: Router, private message: NzMessageService) {
//     this.socket = io(`${environment.root}cms`, {
//       query: { token: localStorage.getItem('token') },
//     });

//     this.socket.on('error', (error) => {
//       // Handle errors
//       if (error.type === 'UnauthorizedError') {
//         localStorage.removeItem('token');
//         this.router.navigate(['./login']);
//         location.reload();
//       }
//     });

//     this.socket.on('disconnect', (reason) => {
//       this.handleDisconnection(reason);
//     });
//   }

//   private handleDisconnection(reason: string): void {
//     this.message.error('WebSocket connection has been disconnected. Reason: ' + reason);
//     console.log('WebSocket connection has been disconnected. Reason: ' + reason);
//   }

//   // Define other methods to interact with the socket as needed
//   public on(event: string, callback: (...args: any[]) => void): void {
//     this.socket.on(event, callback);
//   }

//   public emit(event: string, data: any): void {
//     this.socket.emit(event, data);
//   }
// }
